// Cambiar ruta cuando se suba al servidor
export const API_BASE_URL = "https://pcsisgeco.com/api";
export const API_BASE_URL_DOCS = "https://pcsisgeco.com/";
export const API_BASE_DOCS = "https://pcsisgeco.com";

// export const API_BASE_URL = "http://localhost/presencia_backend/api";
// export const API_BASE_URL_DOCS = "http://localhost/presencia_backend/";
// export const API_BASE_DOCS = "http://localhost/presencia_backend";

// Endpoints del backend
export const ENDPOINTS = {
// PUBLICOS
  login: `${API_BASE_URL}/login.php`,
  getOfertas:`${API_BASE_URL}/ofertas/getOfertas.php`,
  getOfertaById: (id) => `${API_BASE_URL}/ofertas/getOfertaById.php?id=${id}`,
  ExternalUser:`${API_BASE_URL}/usuarios/externalUser.php`,
  getarea:`${API_BASE_URL}/usuarios/getarea.php`,
  getprograma:`${API_BASE_URL}/usuarios/getprogramas.php`,
  ForgotPassword:`${API_BASE_URL}/usuarios/forgotPassword.php`,

// PRIVADOS
// AUTH
  me: `${API_BASE_URL}/usuarios/me.php`,
  updateEmail:`${API_BASE_URL}/usuarios/users/updateEmail.php`,
  updatePassword:`${API_BASE_URL}/usuarios/users/updatePassword.php`,
  verify2FA_login:`${API_BASE_URL}/usuarios/users/verify_2fa.php`,
  enable2FA:`${API_BASE_URL}/usuarios/users/activate_mfa.php`,
  disable2FA:`${API_BASE_URL}/usuarios/users/disable_mfa.php`,
// USUARIO
  getUsers:`${API_BASE_URL}/usuarios/users/getUsers.php`,
  createUser:`${API_BASE_URL}/usuarios/users/createUser.php`,
  resetPassword:`${API_BASE_URL}/usuarios/users/resetPassword.php`,
  changeState:`${API_BASE_URL}/usuarios/users/changeState.php`,
  changerole:`${API_BASE_URL}/usuarios/users/changerole.php`,
// OFERTA
  getOffers:`${API_BASE_URL}/usuarios/ofertas/getOffers.php`,
  changeStateOffer:`${API_BASE_URL}/usuarios/ofertas/changeStateOffer.php`,
  updateOfferById: (id) => `${API_BASE_URL}/usuarios/ofertas/updateOfferById.php?id=${id}`,
  createOffer: `${API_BASE_URL}/usuarios/ofertas/createOffer.php`,
  getActiveOffers: `${API_BASE_URL}/usuarios/ofertas/getActiveOffers.php`,
  // POSTULACION
  createPostulation: `${API_BASE_URL}/usuarios/postulations/createPostulation.php`,
  getMyPostulations: `${API_BASE_URL}/usuarios/postulations/getMyPostulations.php`,
  addPostulation: `${API_BASE_URL}/usuarios/postulations/addPostulation.php`,
  GetPostulacion: `${API_BASE_URL}/usuarios/postulations/getPostulacion.php`,
  GetPostulacionArea: `${API_BASE_URL}/usuarios/postulations/getPostulationArea.php`,
  changeStatePostulation: `${API_BASE_URL}/usuarios/postulations/changeStatePostulation.php`,
  // EXAMEN OCUPACIONAL
  createExamOccupational: `${API_BASE_URL}/usuarios/occupational_exams/createExamOccupational.php`,
  getMyExamOccupational: `${API_BASE_URL}/usuarios/occupational_exams/getMyExamOccupational.php`,
  getOccupationalExam: `${API_BASE_URL}/usuarios/occupational_exams/getOccupationalExams.php`,
  updateOccupationalExamById: `${API_BASE_URL}/usuarios/occupational_exams/updateOccupationalExamById.php`,
  getExamsByUser: `${API_BASE_URL}/usuarios/occupational_exams/getExamsByUser.php`,
  // DASHBOARD RECURSOS HUMANOS
  getBirthdate: `${API_BASE_URL}/usuarios/dashboard/recursos_humanos/getBirthdate.php`,
  getexamenSinRevisar: `${API_BASE_URL}/usuarios/dashboard/recursos_humanos/getexamenSinRevisar.php`,
  getContractFirma: `${API_BASE_URL}/usuarios/dashboard/recursos_humanos/getContractFirma.php`,
  getCountCurriculum: `${API_BASE_URL}/usuarios/dashboard/recursos_humanos/getCountCurriculum.php`,
  getContractEnd: `${API_BASE_URL}/usuarios/dashboard/recursos_humanos/getContractEnd.php`,
  // CURRICULUM
  getCurriculum:`${API_BASE_URL}/usuarios/curriculum/getCurriculum.php`,
  getCurriculumById: (id) =>`${API_BASE_URL}/usuarios/curriculum/getCurriculumById.php?id=${id}`,
  getMyCurriculum: () =>`${API_BASE_URL}/usuarios/curriculum/getMyCurriculum.php`,
  updateCurriculum: (id) => `${API_BASE_URL}/usuarios/curriculum/updateCurriculum.php?id=${id}`,
  getReferences: (id) => `${API_BASE_URL}/usuarios/curriculum/getReference.php?id=${id}`,
  createReference:`${API_BASE_URL}/usuarios/curriculum/createReference.php`,
  updateReference:`${API_BASE_URL}/usuarios/curriculum/updateReference.php`,
  deleteReference:`${API_BASE_URL}/usuarios/curriculum/deleteReference.php`,
  getEducation: (id) => `${API_BASE_URL}/usuarios/curriculum/getEducation.php?id=${id}`,
  createEducation:`${API_BASE_URL}/usuarios/curriculum/createEducation.php`,
  updateEducation:`${API_BASE_URL}/usuarios/curriculum/updateEducation.php`,
  revisedEducation:(id) =>`${API_BASE_URL}/usuarios/curriculum/revisedEducation.php`,
  supportedEducation:(id) =>`${API_BASE_URL}/usuarios/curriculum/supportedEducation.php`,
  getDocsCurriculum: `${API_BASE_URL}/usuarios/curriculum/getDocsCurriculum.php`,
  createDocsCurriculum: `${API_BASE_URL}/usuarios/curriculum/createDocsCurriculum.php`,
  deleteDocCurriculum: `${API_BASE_URL}/usuarios/curriculum/deleteDocCurriculum.php`,

  getUniversities: `${API_BASE_URL}/usuarios/curriculum/getUniversities.php`,
  getDepartment: `${API_BASE_URL}/usuarios/curriculum/getDepartment.php`,
  getMunicipios: (departmentId) =>`${API_BASE_URL}/usuarios/curriculum/getMunicipios.php?departmentId=${departmentId}`,
  // CENTRO DE COSTOS
  getCostcenter: `${API_BASE_URL}/usuarios/cost_center/getCostCenter.php`,
  createCostcenter: `${API_BASE_URL}/usuarios/cost_center/createCostCenter.php`,
  changeStateCostCenter: `${API_BASE_URL}/usuarios/cost_center/changeStateCostCenter.php`,
  getCostCenterActive: `${API_BASE_URL}/usuarios/cost_center/getCostCenterActive.php`,


  // ENTREVISTA
  getInterview:`${API_BASE_URL}/usuarios/interview/getInterview.php`,
  createInterview:`${API_BASE_URL}/usuarios/interview/createInterview.php`,
  // CONTRATOGH
  getContract: `${API_BASE_URL}/usuarios/contract_gh/getContract.php`,
  createContract: `${API_BASE_URL}/usuarios/contract_gh/createContract.php`,
  updateContract: `${API_BASE_URL}/usuarios/contract_gh/updateContract.php`,
  getDocuments: `${API_BASE_URL}/usuarios/contract_gh/getDocuments.php`,
  uploadDocument: `${API_BASE_URL}/usuarios/contract_gh/uploadDocument.php`,
  deleteDocument: `${API_BASE_URL}/usuarios/contract_gh/deleteDocument.php`,
  getCurriculumContract: `${API_BASE_URL}/usuarios/contract_gh/getCurriculumContract.php`,
  getContractByCurriculum: `${API_BASE_URL}/usuarios/contract_gh/getContractByCurriculum.php`,
  getreport: `${API_BASE_URL}/usuarios/contract_gh/getreport.php`,
  // OTRO SI
  getOtrosi: `${API_BASE_URL}/usuarios/contract_gh/otro_si/getOtrosi.php`,
  createOtrosi: `${API_BASE_URL}/usuarios/contract_gh/otro_si/createOtrosi.php`,

  // EXCEL SIN TOKEN
  report_excel : `${API_BASE_URL_DOCS}excel/report_excel.php`,
  report_plan_accion : `${API_BASE_URL_DOCS}excel/report_plan_accion.php`,
  // PDFs (SIN TOKEN)
  certificatePdf: `${API_BASE_URL_DOCS}pdf/fpdf/certificatePdf.php`,
  certificatePdfAll: `${API_BASE_URL_DOCS}pdf/fpdf/certificatePdfAll.php`,
  interviewPdf : `${API_BASE_URL_DOCS}pdf/fpdf/interviewPdf.php`,
  curriculumcertificate : `${API_BASE_URL_DOCS}pdf/fpdf/curriculumcertificate.php`,
  otrosiPdf : `${API_BASE_URL_DOCS}pdf/fpdf/otrosiPdf.php`,

  // MINUTAS DE CONTRATO PDF
  minutaObraLaborHS : `${API_BASE_URL_DOCS}pdf/fpdf/minutas/ObraLaborHogaresSustitutos.php`,
  minutaObraLaborEJC : `${API_BASE_URL_DOCS}pdf/fpdf/minutas/ObraLaborExternadoJornadaCompleta.php`,
  minutaObraLaborIns : `${API_BASE_URL_DOCS}pdf/fpdf/minutas/obralaborinstitucional.php`,
  minutaContratoFijoBC : `${API_BASE_URL_DOCS}pdf/fpdf/minutas/contratofijobuencomienzo.php`,
  minutaContratoFijoIE : `${API_BASE_URL_DOCS}pdf/fpdf/minutas/contratofijo_institucioneducativa.php`,
  minutaContratoFijoAdministrativa : `${API_BASE_URL_DOCS}pdf/fpdf/minutas/contratofijo_area_administrativa.php`,
  minutaContratoIndefinidoAdministrativa : `${API_BASE_URL_DOCS}pdf/fpdf/minutas/contratoindefinido_area_administrativa.php`,
  minutaContratoFijoHS : `${API_BASE_URL_DOCS}pdf/fpdf/minutas/contratofijo_hogares_sustitutos.php`,

  // PLAN DE ACCIÓN
  create_programas: `${API_BASE_URL}/usuarios/plan_accion/create_programas.php`,
  create_program_file: `${API_BASE_URL}/usuarios/plan_accion/create_program_file.php`,
  create_plan: `${API_BASE_URL}/usuarios/plan_accion/create_plan_accion.php`,
  create_fase: `${API_BASE_URL}/usuarios/plan_accion/create_fase.php`,
  create_componente: `${API_BASE_URL}/usuarios/plan_accion/create_componente.php`,
  create_actividad: `${API_BASE_URL}/usuarios/plan_accion/create_actividad.php`,
  create_entregable: `${API_BASE_URL}/usuarios/plan_accion/create_entregable.php`,
  create_tiempo_ejecucion: `${API_BASE_URL}/usuarios/plan_accion/create_tiempo_ejecucion.php`,
  get_fases: `${API_BASE_URL}/usuarios/plan_accion/get_fases.php`,
  get_plan_activo: `${API_BASE_URL}/usuarios/plan_accion/get_plan_activo.php`,
  get_plan: `${API_BASE_URL}/usuarios/plan_accion/get_plan.php`,
  get_componentes: `${API_BASE_URL}/usuarios/plan_accion/get_componentes.php`,
  get_programas: `${API_BASE_URL}/usuarios/plan_accion/get_programas.php`,
  get_program_file: `${API_BASE_URL}/usuarios/plan_accion/get_program_file.php`,
  get_programasAll: `${API_BASE_URL}/usuarios/plan_accion/get_programasAll.php`,
  get_actividades: `${API_BASE_URL}/usuarios/plan_accion/get_actividades.php`,
  get_entregables: `${API_BASE_URL}/usuarios/plan_accion/get_entregables.php`,
  get_tiempo_ejecucion: `${API_BASE_URL}/usuarios/plan_accion/get_tiempo_ejecucion.php`,


  // AREA DE PROYECTOS
  // Entidad
  createEntity: `${API_BASE_URL}/usuarios/mod_proyectos/entity/createEntity.php`,
  getEntity: `${API_BASE_URL}/usuarios/mod_proyectos/entity/getEntity.php`,
  changeStateEntity: `${API_BASE_URL}/usuarios/mod_proyectos/entity/changeStateEntity.php`,
  // Propuesta
  getEntityActive: `${API_BASE_URL}/usuarios/mod_proyectos/proposal/getEntityActive.php`,
  createProposal: `${API_BASE_URL}/usuarios/mod_proyectos/proposal/createProposal.php`,
  getProposal: `${API_BASE_URL}/usuarios/mod_proyectos/proposal/getProposal.php`,
  updateProposal: `${API_BASE_URL}/usuarios/mod_proyectos/proposal/updateProposal.php`,
  getDepartmentCol: `${API_BASE_URL}/usuarios/mod_proyectos/proposal/getDeparmentCol.php`,
  getProposalById: `${API_BASE_URL}/usuarios/mod_proyectos/proposal/getProposalById.php`,
  // Contrato proyectos
  createContratoProyectos: `${API_BASE_URL}/usuarios/mod_proyectos/contrato_proyectos/createContrato.php`,
  getContratoProyecto: `${API_BASE_URL}/usuarios/mod_proyectos/contrato_proyectos/getContrato.php`,
  updateContratoProyectos: `${API_BASE_URL}/usuarios/mod_proyectos/contrato_proyectos/updateContrato.php`,
  // Información Contratual
  createDocInformation: `${API_BASE_URL}/usuarios/mod_proyectos/contractual_information/createDocInformation.php`,
  getDocInformation: `${API_BASE_URL}/usuarios/mod_proyectos/contractual_information/getDocInformation.php`,
  deleteDocInformation:`${API_BASE_URL}/usuarios/mod_proyectos/contractual_information/deleteDocInformation.php`,
  // Asignación de contrato
  getAssignment:`${API_BASE_URL}/usuarios/mod_proyectos/area_assignment/getAssignment.php`,
  createAssignment:`${API_BASE_URL}/usuarios/mod_proyectos/area_assignment/createAssignment.php`,
  getActivateContract:`${API_BASE_URL}/usuarios/mod_proyectos/area_assignment/getActivateContract.php`,
  getProgramAssignment:`${API_BASE_URL}/usuarios/mod_proyectos/area_assignment/getProgramAssignment.php`,


  // SEGUIMIENTO FINANCIERO
  create_informacion_general:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/create_informacion_general.php`,
  get_contratos_asignados:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/get_contratos_asignados.php`,
  get_informacion_general:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/get_informacion_general.php`,
  create_modificacion_financiera:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/create_modificacion_financiera.php`,
  getById_informacion_general:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/getById_informacion_general.php`,
  get_modificaciones_contrato:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/get_modificaciones_contrato.php`,
  get_modificaciones_contrato_all:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/get_modificaciones_contrato_all.php`,
  // FLUJO DE CAJA
  create_flujo_caja:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/flujo_caja/create_flujo_caja.php`,
  get_flujo_caja:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/flujo_caja/get_flujo_caja.php`,
  get_flujo_caja_general:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/flujo_caja/get_flujo_caja_general.php`,
  get_contrato_actual:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/flujo_caja/get_contrato_actual.php`,
  // SEGUIMIENTO TECNICO UNO
  create_seguimiento:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_tecnico/create_seguimiento.php`,
  create_seguimiento_mes:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_tecnico/create_seguimiento_mes.php`,
  get_seguimiento:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_tecnico/get_seguimiento.php`,
  get_seguimiento_general:`${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_tecnico/get_seguimiento_general.php`,
  get_indicadores: `${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_tecnico/get_indicadores.php`,
  save_indicadores: `${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_tecnico/save_indicadores.php`,
  //SEGUIMIENTO TECNICO DOS
  create_seguimiento_tecnico_dos: `${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_tecnico_dos/create_seguimiento_tecnico_dos.php`,
  get_datos_seguimiento_dos: `${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_tecnico_dos/get_datos_seguimiento_dos.php`,
  get_seguimiento_tecnico_dos: `${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_tecnico_dos/get_seguimiento_tecnico_dos.php`,
  save_datos_seguimiento_dos: `${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_tecnico_dos/save_datos_seguimiento_dos.php`,
  get_seguimientos_programa: `${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_tecnico_dos/get_seguimientos_programa.php`,
  get_seguimiento_dos_general: `${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_tecnico_dos/get_seguimiento_dos_general.php`,
  // SEGUIMIENTO FINANCIERO
  get_seguimiento_financiero: `${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_financiero/get_seguimiento_financiero.php`,
  update_seguimiento_financiero: `${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_financiero/update_seguimiento_financiero.php`,
  get_seguimiento_financiero_general: `${API_BASE_URL}/usuarios/mod_administracion/seguimiento_financiero/seguimiento_financiero/get_seguimiento_general.php`,
};
